import React, { useState, useEffect, useMemo } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Switch } from "antd";

import Pagination from "@material-ui/lab/Pagination";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Button from "components/CustomButtons/Button.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";


import Search from "@material-ui/icons/Search";
import CustomInput from "components/CustomInput/CustomInput.js";
import SomeSpinner from "components/Somespinner/Somespinner.js";

import TableOrderSellsman from "components/TableOrderSellsman/TableOrderSellsman";

import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";
import { grayColor } from "assets/jss/material-dashboard-react.js";


import styles5 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import styles6 from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import ModalAddOrderSellsman from "components/ModalAddOrderSellsman/ModalAddOrderSellsman";

const styles3 = {
  amountbox: {
    fontSize: "14px",
  },
  MT: {
    marginTop: "-18px",
  },
};

const styles4 = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  colorCard: {
    color: "#999",
    marginTop: "10px",
    marginBottom: "-1em",
    fontSize: "12px",
  },
  floatRight: {
    float: "right",
  },
  maxwidht: {
    maxWidth: "107%",
  },
  toogleclass: {
    marginTop: "15px",
    marginBottom: "15px",
    width: "65%",
  },
  backGreen: {
    backgroundColor: "#4caf50",
  },
  backRed: {
    backgroundColor: "rgb(244 67 54 / 1)",
  },
  zindex: {
    zIndex: "0 !important",
  },
  marginDate: {
    marginTop: "12px",
    marginBottom: "12px",
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "7px",
    marginTop: "0",
    paddingTop: "0px",
    marginBottom: "0",
  },
  sizeAmount: {
    fontSize: "20px",
  },
  marginFor: {
    marginTop: "-10px",
  },
  fontSizeOf: {
    fontSize: "10px",
  },
  marg: {
    float: "left",
  },
  List: {
    border: "1px solid #d9dddd",
  },
  mgTop: {
    marginTop: "12px",
    float: "left",
    position: "relative",
    marginLeft: "3px",
  },
  tp: {
    marginTop: "10px",
  },
  center: {
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
  },
};

const useStyles4 = makeStyles(styles4);
const useStyles5 = makeStyles(styles5);
const useStyles6 = makeStyles(styles6);

const useStyles3 = makeStyles(styles3);
const useStyles2 = makeStyles(styles2);
const useStyles = makeStyles(styles);


export default function OrderSellsman() {

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const classes = useStyles();
  const classes2 = useStyles2();
  const classes3 = useStyles3();
  const classes4 = useStyles4();
  const classes5 = useStyles5();
  const classes6 = useStyles6();

  const { storageId, garlicType } = useAuth();

  //interactions for page
  const [loading, setLoading] = useState(false);

  //params for searchs
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setSearch] = useState("");
  const [toogle, setToggle] = useState(false);
  const [toogleCancel, setToogleCancel] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  //data orders
  const [orders, setOrders] = useState([]);

  //interactions modal
  const [modal, setModal] = useState(false);
  const [importModal, setImportModal] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadOrders();
    }, 900);
    return () => clearTimeout(delayDebounceFn);
  }, [search, toogle, toogleCancel, startDate, endDate]);

  useEffect(() => {
    loadOrders();
  }, []);

  useEffect(() => {
    loadOrders();
  }, [page, garlicType]);

  const loadModal = async () => {
    setImportModal(true);
  }

  const openModal = () => {
    if (!modal) {
      loadModal();
    }
    setModal(true);
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const loadOrders = async () => {
    try {
      const response = await api.get(`/order/sellsman/web/${storageId}?page=${page}&perPage=${perPage}&garlic=${garlicType}&cancel=${toogleCancel}&invoice=${toogle}&search=${search}&init_date=${startDate}&end_date=${endDate}`);
      if (page > 1 && !toogle) {
        setOrders([...orders, ...response.data.orders]);
      } else {
        setOrders(response.data.orders);
      }
      setTotalPages(response.data.totalPages);
    } catch (error) {

    }
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={2}>
        <Card className={classes4.marginFor}>
          <div className="d-flex justify-content-center">
            <p className={classes4.colorCard}>
              Clique abaixo para inserir <b>filtro</b> de data primária
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <DatePicker
              className={classes4.marginDate + " " + classes4.zindex}
              selected={startDate}
              onChange={(date) =>
                date ? setStartDate(date.withoutTime()) : setStartDate(null)
              }
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              disabledKeyboardNavigation
              locale={pt}
            />
          </div>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card className={classes4.marginFor}>
          <div className="d-flex justify-content-center">
            <p className={classes4.colorCard}>
              Clique abaixo para inserir <b>filtro</b> de data secundária{" "}
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <DatePicker
              className={classes4.marginDate}
              selected={endDate}
              onChange={(date) =>
                date ? setEndDate(date.withoutTime()) : setEndDate(null)
              }
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              disabledKeyboardNavigation
              locale={pt}
            />
          </div>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={1}>
        <Card className={classes4.marginFor}>
          <div className="d-flex justify-content-center">
            <p className={classes4.colorCard}>
              <b>filtro</b> para faturados
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <Switch className={classes4.toogleclass} onClick={() => setToggle(!toogle)} />
          </div>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={1}>
        <Card className={classes4.marginFor}>
          <div className="d-flex justify-content-center">
            <p className={classes4.colorCard}>
              <b>filtro</b> de cancelados
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <Switch className={classes4.toogleclass} onClick={() => setToogleCancel(!toogleCancel)} />
          </div>
        </Card>
      </GridItem>

      <GridItem xs={6} sm={6} md={1}  >
        <Card className={classes4.marginFor}>
          <div className="d-flex justify-content-center">
            <Button color="success" onClick={openModal} >
              Adicionar pedido
            </Button>
          </div>
        </Card>
      </GridItem>
      <div className={classes4.zindex}>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes5.searchWrapper}>
            <CustomInput
              formControlProps={{
                className: classes5.margin + " " + classes5.search,
              }}
              inputProps={{
                placeholder: "Busca por pedido, razão social ou nome fantasia",
                inputProps: {
                  "aria-label": "Search",
                  type: "text",
                  value: search,
                  onChange: (event) => setSearch(event.target.value),
                },
              }}
            />
            <Button color="white" aria-label="edit" justIcon round>
              <Search />
            </Button>
          </div>
        </GridItem>
      </div>
      {orders.map((order, index) =>
      (
        <TableOrderSellsman
          key={`order_${order.order_controller}`}
          order={order}
          indexOfOrder={index}
          loadOrders={loadOrders}
        />
      )
      )}
      <GridItem xs={12} sm={12} md={9}>
        {loading ? (
          <div>
            <SomeSpinner />
          </div>
        ) : (
          <div></div>
        )}
        {toogle ? (
          <Pagination count={totalPages} page={page} onChange={handleChange} />
        ) : (
          <div>
            {totalPages !== page ? (
              <div className="d-flex justify-content-center">
                <div className={classes2.marginT}>
                  <Tooltip
                    id="tooltip-top"
                    title={"Descer"}
                    placement="top"
                    classes={{ tooltip: classes2.tooltip }}
                  >
                    <IconButton
                      aria-label="Done"
                      className={classes2.tableActionButton}
                      onClick={() => setPage(page + 1)}
                    >
                      <KeyboardArrowDownIcon
                        className={
                          classes2.tableActionButtonIconArrow +
                          " " +
                          classes2.edit3
                        }
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        )}
      </GridItem>
      {modal && importModal && (
        <ModalAddOrderSellsman
          key={String("Ord_")}
          show={modal}
          onHide={() => setModal(false)}
          LoadOrders={loadOrders}
          props={{ id: 1 }}
        />
      )}
    </GridContainer>

  );
}
